import React, { useState } from 'react';
import { useDashboardData } from '../hooks/useDashboardData';
import DashboardHeader from '../components/dashboard/DashboardHeader';
import DashboardStats from '../components/dashboard/DashboardStats';
import ProjectGroupGrid from '../components/dashboard/ProjectGroupGrid';
import TasksSidebar from '../components/dashboard/TasksSidebar';
import LoadingScreen from '../components/dashboard/LoadingScreen';

// Modal imports
import AddProjectGroupModal from '../components/project-groups/AddProjectGroupModal';
import EditProjectGroupModal from '../components/project-groups/EditProjectGroupModal';
import DeleteProjectGroupModal from '../components/project-groups/DeleteProjectGroupModal';
import AddProjectModal from '../components/projects/AddProjectModal';
import AddTaskModal from '../components/tasks/AddTaskModal';

function Home() {
  const { projectGroups, quickTasks, projects, loading, user, refetch } = useDashboardData();

  // Modal state management
  const [showAddGroupModal, setShowAddGroupModal] = useState(false);
  const [showEditGroupModal, setShowEditGroupModal] = useState(false);
  const [showDeleteGroupModal, setShowDeleteGroupModal] = useState(false);
  const [showAddProjectModal, setShowAddProjectModal] = useState(false);
  const [showAddTaskModal, setShowAddTaskModal] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedGroupId, setSelectedGroupId] = useState(null);

  const handleAddProjectGroup = () => {
    setShowAddGroupModal(true);
  };

  const handleEditProjectGroup = (group) => {
    setSelectedGroup(group);
    setShowEditGroupModal(true);
  };

  const handleDeleteProjectGroup = (group) => {
    setSelectedGroup(group);
    setShowDeleteGroupModal(true);
  };

  const handleAddProject = (groupId) => {
    setSelectedGroupId(groupId);
    setShowAddProjectModal(true);
  };

  const handleAddTask = () => {
    setShowAddTaskModal(true);
  };

  const handleStartPomodoro = () => {
    // TODO: Implement pomodoro timer
    console.log('Starting pomodoro timer...');
    // You could open a pomodoro modal, start a timer, or navigate to a pomodoro page
  };

  const handleNewProject = () => {
    setSelectedGroupId(null); // No specific group selected
    setShowAddProjectModal(true);
  };

  // Refresh data after modal actions
  const handleDataRefresh = () => {
    if (refetch) {
      refetch();
    }
  };

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <DashboardHeader 
        user={user} 
        onStartPomodoro={handleStartPomodoro}
        onQuickAdd={handleAddTask}
      />
      
      <div className="max-w-7xl mx-auto px-6 py-8">
        <DashboardStats projectGroups={projectGroups} quickTasks={quickTasks} />
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <ProjectGroupGrid 
              projectGroups={projectGroups} 
              onAddProjectGroup={handleAddProjectGroup}
              onEditProjectGroup={handleEditProjectGroup}
              onDeleteProjectGroup={handleDeleteProjectGroup}
              onAddProject={handleAddProject}
            />
          </div>
          
          <div className="lg:col-span-1">
            <TasksSidebar 
              quickTasks={quickTasks}
              onAddTask={handleAddTask}
              onStartPomodoro={handleStartPomodoro}
              onNewProject={handleNewProject}
            />
          </div>
        </div>
      </div>

      {/* Modals */}
      <AddProjectGroupModal
        show={showAddGroupModal}
        handleClose={() => setShowAddGroupModal(false)}
        userId={user?.id}
        onProjectGroupAdded={handleDataRefresh}
      />

      <EditProjectGroupModal
        show={showEditGroupModal}
        handleClose={() => setShowEditGroupModal(false)}
        item={selectedGroup}
        onItemUpdated={handleDataRefresh}
      />

      <DeleteProjectGroupModal
        show={showDeleteGroupModal}
        handleClose={() => setShowDeleteGroupModal(false)}
        projectGroup={selectedGroup}
        onProjectGroupDeleted={handleDataRefresh}
      />

      <AddProjectModal
        show={showAddProjectModal}
        handleClose={() => setShowAddProjectModal(false)}
        projectGroups={projectGroups}
        selectedGroupId={selectedGroupId}
        onProjectAdded={handleDataRefresh}
      />

      <AddTaskModal
        show={showAddTaskModal}
        handleClose={() => setShowAddTaskModal(false)}
        projects={projects}
        onTaskAdded={handleDataRefresh}
      />
    </div>
  );
}

export default Home;
